import React, {CSSProperties} from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../hooks/use-services.hook";

export const TicketStandByLabelComponent: React.FC = observer(() => {
    const services = useServices();
    const styles: CSSProperties = {
        display: 'flex',
        alignItems: "center",
        justifyContent: 'center',
        width: '100%',
        color: services.theme.currentTheme.colors.dangerShade,
        fontWeight: services.theme.currentTheme.fontWeight.semiBold
    };

    return (
        <div style={styles}>
            {services.language.translate('Standby')}
        </div>
    );
})
